// Returns the workspace id that vendor / companyList writes should target.
// TAWs (teamRole === 'team_agent') write to their parent TW so the team
// vendor pool stays canonical. Standalone TWs / solo workspaces write to
// themselves. Returns null on broken state (TAW missing parentWorkspaceId)
// so callers can refuse the write and surface an error.

export function resolveVendorTargetWorkspaceId(selectedWorkspace) {
    if (!selectedWorkspace) return null;
    if (selectedWorkspace.teamRole === 'team_agent') {
        return selectedWorkspace.parentWorkspaceId || null;
    }
    return selectedWorkspace.id || null;
}
